import React from 'react';
import { Chip } from '@mui/material';
import ApartmentIcon from '@mui/icons-material/Apartment';
import CategoryIcon from '@mui/icons-material/Category';
import PublicIcon from '@mui/icons-material/Public';
import StorageIcon from '@mui/icons-material/Storage';
import EventNoteIcon from '@mui/icons-material/EventNote';
import PaymentsIcon from '@mui/icons-material/Payments';
import { schoolCompleteness, isExistingLink, isNewSchoolRow } from './schoolsListUtils';
import { RailShell, RailGroup, RailFact, RailChips, RailGatingHint } from '../../../components/common/SummaryRailParts';

// At-a-glance panel shown alongside every wizard step: the group facts, the subscription
// headline and the school tally with live incomplete/duplicate validation chips.
const subscriptionTotal = (values) => {
  const year1 = parseFloat(values.Year1Cost || 0);
  const year2 = parseFloat(values.Year2Cost || 0);
  const year3 = parseFloat(values.Year3Cost || 0);
  const discount = parseFloat(values.Discount || 0);
  const subtotal = year1 + year2 + year3 - discount;
  const vat = subtotal * (parseFloat(values.VatPercentApplied || 0) / 100);
  return (subtotal + vat).toFixed(2);
};

export default function SummaryRail({ values = {}, schools = [], warnings = [] }) {
  const existing = schools.filter(isExistingLink);
  const newSchools = schools.filter(isNewSchoolRow);
  const duplicates = schools.filter((row) => row.duplicate).length;
  const incomplete = newSchools.filter((row) => !schoolCompleteness(row.values).complete).length;
  const blocked = duplicates > 0 || incomplete > 0;

  return (
    <RailShell>
      <RailGroup title="Group" first>
        <RailFact icon={<ApartmentIcon />} label="Name" value={values.Name} />
        <RailFact icon={<CategoryIcon />} label="Type" value={values.GroupType} />
        <RailFact icon={<PublicIcon />} label="Country" value={values.Country} />
        <RailFact icon={<StorageIcon />} label="Storage" value={values.DataStorageLocation} />
      </RailGroup>

      <RailGroup title="Subscription">
        <RailFact icon={<EventNoteIcon />} label="Term" value={values.SubscriptionTerm ? `${values.SubscriptionTerm} year(s)` : ''} />
        <RailFact icon={<PaymentsIcon />} label="Total" value={`£${subscriptionTotal(values)}`} />
      </RailGroup>

      <RailGroup title="Schools">
        <RailChips>
          <Chip size="small" label={`${existing.length} existing`} />
          <Chip size="small" color="primary" label={`${newSchools.length} new`} />
          {incomplete > 0 && <Chip size="small" color="warning" label={`${incomplete} incomplete`} />}
          {duplicates > 0 && <Chip size="small" color="error" label={`${duplicates} duplicate`} />}
        </RailChips>
      </RailGroup>

      {warnings.map((warning, index) => (
        <RailGatingHint key={index} blocked message={warning} />
      ))}
      <RailGatingHint
        blocked={blocked && warnings.length === 0}
        message="Resolve the highlighted schools before creating the group."
      />
    </RailShell>
  );
}
